import localScaleManager from "../../../../helpers/LocalScaleManager";
import { tweenConfigs } from "../../../../helpers/tweensConfigs";
import { WebSocketManager } from "../../../../helpers/webSocketManager";

export class IdleSeat extends Phaser.GameObjects.Image {
  /**
   * @param scene {GameScene}
   * @param table {Table}
   * @param seat {Seat}
   */
  constructor(scene, table, seat) {
    super(scene, 0, 0, scene.atlasTexture, "idle-seat");
    // super(scene, 0, 0, 'idle-seat');
    this.scene = scene;
    this.table = table;
    this.seat = seat;
    this.pointerDowned = false;
    this.scene.add.existing(this);
    this.table.poolArray.push(this);

    this.setOrigin(0.5);
    this.setInteractive({ cursor: "pointer" });
    this.on("pointerdown", this.onPointerDown);
    this.on("pointerup", this.onPointerUp);
    this.userLatitude = null;
    this.userLongitude = null;
    this.alert = null;
  }
  onPointerDown() {
    this.pointerDowned = true;
  }
  onPointerUp() {
    if (this.pointerDowned) {
      if (this.table.tableInfo.gpsRestriction) {
        this.table.loading.show();
        this.scene
          .getPlayerLocation()
          .then((res) => {
            this.userLatitude = res.lat;
            this.userLongitude = res.lng;
            this.table.loading.hide();
            this.seatPlayer()
              .then(() => {
                this.pointerDowned = false;
                this.scene.setATimeout(() => {
                  this.setInteractive({ cursor: "pointer" });
                }, 2000);
              })
              .catch(() => {
                this.setInteractive({ cursor: "pointer" });
                this.pointerDowned = false;
              });
          })
          .catch(() => {
            this.table.loading.hide();
            this.setInteractive({ cursor: "pointer" });
            this.pointerDowned = false;
          });
        return;
      }
      this.disableInteractive();
      this.seatPlayer()
        .then(() => {
          this.pointerDowned = false;
          this.scene.setATimeout(() => {
            this.setInteractive({ cursor: "pointer" });
          }, 2000);
        })
        .catch(() => {
          this.setInteractive({ cursor: "pointer" });
          this.pointerDowned = false;
        });
    }
  }
  async seatPlayer() {
    if (!this.table.seatManager.hasSelfPlayerSat()) {
      return new Promise((resolve, reject) => {
        WebSocketManager.emitEvent(
          {
            tableId: this.table.tableInfo.id,
            clubId: this.scene.getURLClubId(),
            seat: this.seat.serverPosition,
            latitude: this.userLatitude ? this.userLatitude : null,
            longitude: this.userLongitude ? this.userLongitude : null,
          },
          "poker.client-push.reserve"
        )
          .then(() => {
            resolve();
          })
          .catch((error) => {
            console.log(error);
            reject();
          });
      });
    }
  }
  visibilityControls(visibility, tween) {
    // this.setVisible(visibility);
    if (tween) {
      if (!visibility) {
        this.scene.tweens.add({
          targets: this,
          duration: tweenConfigs.idleSeatHide.duration,
          ease: tweenConfigs.idleSeatHide.ease,
          alpha: 0,
          onComplete: () => {
            if (this.visible !== visibility) this.setVisible(visibility);
            this.alpha = 0;
          },
        });
      }
    } else {
      if (this.visible !== visibility) this.setVisible(visibility);
      this.alpha = visibility ? 1 : 0;
    }
  }
  /***
   *
   * @param scale
   * @param width {number} width of seat box
   * @param height {number} width of seat box
   * @param initX {number} seat box top left x
   * @param initY {number} seat box top left y
   */
  positionControls(scale, width, height, initX, initY) {
    localScaleManager.scaleSprite(this, scale, scale, 0, 1, true);
    this.setPosition(initX, initY);
  }
  /***
   *
   * @param scale
   * @param width {number} width of seat box
   * @param height {number} width of seat box
   * @param initX {number} seat box top left x
   * @param initY {number} seat box top left y
   */
  reposition(scale, width, height, initX, initY) {
    this.setPosition(initX, initY);
  }
  remove() {
    this.destroy();
  }
}
